import React from 'react';
import FocusTrap from 'focus-trap-react';
import styles from './index.module.scss';
import { Modal, Button, ButtonStyle } from '@cmp/common';
import BannerPending from '@img/landing/banner/banner_pending@2x.jpg';
import { deauth } from '@helpers/auth';
import { withTranslation } from 'react-i18next';

function PendingModal({ t, history, location, title }) {
  const navigateHome = () => {
    history.push({
      pathname: '/',
      state: { from: location, modal: false },
    });
  };

  return (
    <FocusTrap>
      <Modal.Base className={styles.StripeModal} onClose={navigateHome}>
        <img src={BannerPending} className={styles.Banner} />
        <div className={styles.Container}>
          <h2 className={styles.Heading}>{title}</h2>
          <p className={styles.Text}>{t('profile_PendingApprovalText_1')}</p>
          <p className={styles.Text}>{t('profile_PendingApprovalText_2')}</p>
          <p className={styles.Text}>{t('profile_PendingApprovalText_3')}</p>
          <div className={styles.ButtonContainer}>
            <Button
              style={ButtonStyle.Custom}
              onClick={() => deauth()}
              className={styles.LogoutButton}
            >
              {t('profile_PendingApprovalLogout')}
            </Button>
            <p className={styles.Text}>{t('profile_PendingApprovalOr')}</p>
            <Button
              style={ButtonStyle.Secondary}
              onClick={navigateHome}
              className={styles.Button}
            >
              {t('profile_PendingApprovalBtnText')}
            </Button>
          </div>
        </div>
      </Modal.Base>
    </FocusTrap>
  );
}

export default withTranslation()(PendingModal);
